// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-c5046afa]{font-size:38px;font-weight:600}.row[data-v-c5046afa]{font-size:22px;margin-top:34px;text-align:justify}.icons[data-v-c5046afa]{display:flex;justify-content:center;margin-top:60px}.icons img[data-v-c5046afa]{height:45px;margin-bottom:20px}.icons .icon[data-v-c5046afa]{text-align:center}.icons .icon[data-v-c5046afa]:not(:last-child){margin-right:150px}.why-buy[data-v-c5046afa]{padding-bottom:60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
